import { createVNode as n, mergeProps as o } from "vue";
import s from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MinusOutlined.js";
import u from "../components/PfIcon.js";
const t = (r, e) => {
  const i = {
    ...r,
    ...e.attrs
  };
  return n(u, o(i, {
    icon: s
  }), null);
};
t.displayName = "MinusOutlined";
t.inheritAttrs = !1;
export {
  t as default
};
